import { NdbxIconModule } from '@allianz/ngx-ndbx/icon';
import { Component, inject, input, output, viewChild } from '@angular/core';
import { NxErrorModule } from '@aposin/ng-aquila/base';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxCopytextModule } from '@aposin/ng-aquila/copytext';
import { FileItem, NxFileUploaderComponent, NxFileUploaderModule } from '@aposin/ng-aquila/file-uploader';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NxPopoverModule } from '@aposin/ng-aquila/popover';
import { TranslateModule } from '@ngx-translate/core';

import UserService from '#services/user/user.service';

@Component({
  selector: 'kyc-file-uploader',
  templateUrl: 'file-uploader.component.html',
  imports: [
    NxButtonModule,
    NxFileUploaderModule,
    NxIconModule,
    NxCopytextModule,
    NdbxIconModule,
    NxPopoverModule,
    NxErrorModule,
    TranslateModule,
  ],
})
export class FileUploaderComponent {
  readonly filesChange = output<FileItem[]>();
  readonly fileDeletion = output<FileItem>();
  readonly showOptional = input(false);
  readonly value = input<FileItem[] | undefined>([]);
  readonly maxFileNumber = input<number | undefined>();
  readonly acceptedMimeTypes = input([
    'text/csv',
    'text/plain',
    'image/*',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.oasis.opendocument.presentation',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.ms-outlook',
  ]);
  private readonly fileUploader = viewChild(NxFileUploaderComponent);

  protected readonly userService: UserService = inject(UserService);

  protected readonly maxFileSize = 10 * 1024 * 1024;

  public readonly removeFile = (file: FileItem) => this.fileUploader()?.removeFile(file);

  protected filesSelected(files: FileItem[]) {
    this.filesChange.emit(files);
  }

  protected fileDeleted(file: FileItem) {
    this.fileDeletion.emit(file);
  }
}
